export const WidgetConstants = {
    WIDGET_HELP_CENTER_HAS_SESSION: 'widgetHelpCenterHasSession',
    SHOW_WIDGET: 'showWidget',
    BLIP_CHAT_SHOW_CLOSE_BUTTON: 'ShowCloseButton',
};
export const WidgetConstantsTracks = {
    HELPDESK_WIDGET_CHAT_OPEN: 'helpdesk-widget-chat-open',
    HELPDESK_WIDGET_BLIP: 'helpdesk-widget-blip',
    HELPDESK_WIDGET_CHAT_CLOSE: 'helpdesk-widget-chat-close',
};
